import { environment } from 'services/apiConfigs';

const getGoogleApi = () => window.gapi;

const scopes = 'https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.coursework.students https://www.googleapis.com/auth/classroom.coursework.me https://www.googleapis.com/auth/classroom.coursework.me.readonly https://www.googleapis.com/auth/classroom.coursework.students.readonly';
const student_scopes = 'https://www.googleapis.com/auth/classroom.coursework.me.readonly https://www.googleapis.com/auth/classroom.coursework.me';

//:TODO change this
const client_id =
  environment === 'production'
    ? "190107651153-l43gv52jpp68thvm4vn036ukq0pbp3ju.apps.googleusercontent.com"
    : process.env.GOOGLE_CLIENT_ID_STAGING;

// Private Methods
const initClient = (role) => {
  return new Promise((resolve, reject) => {
    getGoogleApi().load('client:auth2', () => {
      return getGoogleApi()
        .auth2.init({ client_id: client_id, })
        .then(async () => {
          const authInstance = await getGoogleApi().auth2.getAuthInstance();
          const scope = role === 'teacher' ? scopes : student_scopes;
          const { code } = await authInstance.grantOfflineAccess({ scope });
          const email = await authInstance.currentUser.get().getBasicProfile().getEmail();
          return { code, email };
        })
        .then(resolve)
        .catch(reject);
    });
  });
};


const getCode = (role = 'teacher') => {
  return initClient(role);
};


export default {
  getCode,
};



// WEBPACK FOOTER //
// ./src/app/utils/googleClassroom.js